import { useMemo } from "react";
import { motion } from "framer-motion";
import { useTheme } from "../../hooks/useTheme";

// Light mode color palette — vivid enough to show against white/lavender bg
const LIGHT_COLORS = ["#8B5CF6", "#C084FC", "#06B6D4", "#A78BFA", "#22D3EE"];
// Dark mode color palette
const DARK_COLORS = ["#b389ff", "#79bdff", "#c4b5fd", "#67e8f9"];

export const Particles = ({ count = 32 }) => {
    const { theme } = useTheme();

    const particles = useMemo(
        () =>
            Array.from({ length: count }).map((_, i) => {
                const isLight = Math.random() > 0.5;
                return {
                    id: i,
                    left: Math.random() * 100,
                    size: Math.random() * 2.4 + 0.7,
                    delay: Math.random() * 8,
                    duration: 12 + Math.random() * 18,
                    // Light needs slightly higher base opacity to read on white bg
                    opacityLight: 0.45 + Math.random() * 0.40,
                    opacityDark:  0.18 + Math.random() * 0.52,
                    hueLight: LIGHT_COLORS[Math.floor(Math.random() * LIGHT_COLORS.length)],
                    hueDark:  DARK_COLORS[Math.floor(Math.random() * DARK_COLORS.length)],
                    drift: (Math.random() - 0.5) * 40,
                };
            }),
        [count]
    );

    const isDark = theme === "dark";

    return (
        <div
            aria-hidden
            className="pointer-events-none absolute inset-0 overflow-hidden"
        >
            {particles.map((p) => {
                const hue     = isDark ? p.hueDark  : p.hueLight;
                const opacity = isDark ? p.opacityDark : p.opacityLight;
                const glow    = isDark ? p.size * 4 : p.size * 5;
                return (
                    <motion.span
                        key={p.id}
                        className="absolute rounded-full"
                        style={{
                            left: `${p.left}%`,
                            bottom: -10,
                            width:  p.size,
                            height: p.size,
                            background: hue,
                            boxShadow: `0 0 ${glow}px ${hue}`,
                            opacity,
                        }}
                        initial={{ y: 0, x: 0 }}
                        animate={{
                            y: ["0vh", "-110vh"],
                            x: [0, p.drift, -p.drift, 0],
                        }}
                        transition={{
                            duration: p.duration,
                            delay:    p.delay,
                            repeat:   Infinity,
                            ease:     "linear",
                        }}
                    />
                );
            })}
        </div>
    );
};

export default Particles;
